import { useSelector } from 'react-redux'
import { useUserActions } from '../store/slices/UserSlice'

const useUser = () => {
    const { cleanForm } = useUserActions()

    const formHasErrored = useSelector(
        state => state?.UserSlice?.formHasErrored,
    )
    const formIsLoading = useSelector(state => state?.UserSlice?.formIsLoading)
    const formSuccess = useSelector(state => state?.UserSlice?.formSuccess)

    return {
        formHasErrored,
        formIsLoading,
        formSuccess,
        cleanForm,
    }
}

export default useUser
